





















import { Component, Vue, Prop } from 'vue-property-decorator'
import { EnhancedPost } from '~base/common/types'

@Component
export default class BreadCrumbs extends Vue {
  @Prop({ type: Object, required: true })
  readonly post!: EnhancedPost

  get postCategory() {
    if (this.post.relevantCategories) {
      return this.post.relevantCategories[0]
    }

    return { slug: 'keine-kategorie' }
  }

  get siteName() {
    return this.$config.siteShortName
  }
}
